/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import axios from 'axios'
import apiConnect from '../../../api/apiConnect'
import Swal from 'sweetalert2'
import {useUser} from '../../../modules/newauth/UserContext'

const InformationTab = ({deviceData, trigger, setTrigger}) => {
  const [editLimitParameter, setEditLimitParameter] = useState(false)
  const [limitParameter, setLimitParameter] = useState(deviceData?.limitParameter || 20)
  const {user} = useUser()

  const handleSubmitLimitParameter = async () => {
    const payload = {
      deviceId: deviceData?.device_id,
      limitParameter: limitParameter,
    }

    try {
      const response3 = await apiConnect.post('/v1/devices/update-limit-parameter', payload)

      console.log(response3)
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
      })
    }
    setTrigger(!trigger)
    setEditLimitParameter(false)
  }

  return (
    <>
      <div className='mb-5'>
        <div className='row mb-5'>
          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Alarm (Email/Line)</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.alarm?.email
                    ? `(${deviceData?.alarm?.email} / ${deviceData?.alarm?.line})`
                    : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Alarm Day</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.alarm_day ? deviceData?.alarm_day : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Cloud Region</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.cloud_region ? deviceData?.cloud_region : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Device Id</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.device_id ? deviceData?.device_id : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Device Manufacturer</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.device_manufacturer ? deviceData?.device_manufacturer : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Device Model</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.device_model ? deviceData?.device_model : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Gateway Code</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.gateway_code ? deviceData?.gateway_code : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Gateway Id</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.gateway_id ? deviceData?.gateway_id : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>IOT</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.iot ? deviceData?.iot : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Last Status</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.last_status ? deviceData?.last_status : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row'>
              <label className='col-lg-4 fw-bold text-muted'>Device Name</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.name ? deviceData?.name : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Owner</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.owner ? deviceData?.owner : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Premium</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.premium ? 'Yes' : 'No'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Registry Id</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.registry_id ? deviceData?.registry_id : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Status</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.status ? deviceData?.status : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Timestamp</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.timestamp ? getTimeFormat(deviceData?.timestamp) : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Transaction Count</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.transaction_count ? deviceData?.transaction_count : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Type</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.type ? deviceData?.type : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Update Interval</label>

              <div className='col-lg-8'>
                <span className='fw-bolder fs-6 text-dark'>
                  {deviceData?.update_interval ? deviceData?.update_interval : '-'}
                </span>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-12 mb-5'>
            <div className='row '>
              <label className='col-lg-4 fw-bold text-muted'>Limit Parameter</label>

              <div className='col-lg-7'>
                {editLimitParameter ? (
                  <>
                    <div className='d-flex'>
                      <div className='col-lg-10'>
                        <select
                          className='form-select'
                          value={limitParameter}
                          onChange={(e) => setLimitParameter(e.target.value)}
                        >
                          <option value={20}>20</option>
                          <option value={40}>40</option>
                          <option value={60}>60</option>
                        </select>
                      </div>
                      <div className='col-lg-2'>
                        <div
                          onClick={() => handleSubmitLimitParameter()}
                          className='btn btn-icon btn-primary ms-2'
                        >
                          <i className='fas fa-circle-check fs-4'></i>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <span className='fw-bolder fs-6 text-dark'>
                      {deviceData?.limitParameter ? deviceData?.limitParameter : '-'}
                    </span>
                    {user?.role === 'admin' && (
                      <div
                        onClick={() => setEditLimitParameter(true)}
                        className='btn btn-icon btn-warning ms-2 btn-sm'
                      >
                        <i className='fas fa-pen-to-square fs-4'></i>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {InformationTab}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
